import {gql} from '@apollo/client';

export const ArtworkComplete = {
  artwork: gql`
    fragment ArtworkComplete on Artwork {
      smallUrl
      mediumUrl
      largeUrl
      textColor1
      textColor2
      textColor3
      textColor4
      backgroundColor
    }
  `,
};
